import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl } from '@angular/forms';

@Directive({
    selector: 'input[maxValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MaxValueDirective, multi: true }],
    standalone: false
})
export class MaxValueDirective implements Validator {
  @Input()
  maxValue: number;
  @Input() messageFieldType: string = "number";

  validate(c: FormControl): { [key: string]: any } {
    let v = parseFloat(c.value?.toString().replace(/,/g,'.'));
    return (!Number.isNaN(v) && v > this.maxValue) ? { [this.getErrorName()] : this.maxValue} : null;
  }

  getErrorName(): string {
    switch (this.messageFieldType) {
      case ("number"):
        return "maxValue";
      case ("currency"):
        return "maxCurrency";
      case ("percentage"):
        return "maxPercentage"
      default:
        return "maxValue"
    }
  }
}

@Directive({
    selector: 'input[minValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValueDirective, multi: true }],
    standalone: false
})
export class MinValueDirective implements Validator {
  @Input()
  minValue: number;
  @Input() messageFieldType: string = "number";

  
  validate(c: FormControl): { [key: string]: any } {
    let v = parseFloat(c.value?.toString().replace(/,/g, '.'));
    return (!Number.isNaN(v) && v < this.minValue) ? { [this.getErrorName()] : this.minValue } : null;
}
  getErrorName(): string {
    switch (this.messageFieldType) {
      case ("number"):
        return "minValue";
      case ("currency"):
        return "minCurrency";
      case ("percentage"):
        return "minPercentage"
      default:
        return "minValue"
    }
  }
} 
